<!--订单详情页-->
<template>
  <div id="order-detail" v-loading="loading">
    <LYForm style="width: 100%" :formData="orderData" :displayData="formConfig()"
      class="order-detail-form" ref="form" :rules="formRules" :opts="formOpts()">
    </LYForm>

    <el-card style="margin-top:10px">
      <h2 class="order-detail_detail-title">货物详情</h2>
      <el-table :data="orderData.goods" class="tb-edit" style="width: 100%"
        :row-class-name="tableRowClassName" highlight-current-row>
        <el-table-column v-for="(item,index) in goodsColumns" :key="index"
          :prop="item.prop" :label="item.label" :width="item.width"
          :class-name="item.class" :render-header="renderHeader">
          <template scope="scope">
            <!-- <template v-if="index == 0 && scope.row.no == '合计'">
              {{scope.row.no}}
            </template> -->
            <template v-if="index == 0">
              <el-switch :disabled="!editing" v-model="scope.row.type" @change="()=>onChangeRowType(scope.row)"
                active-color="#13ce66" inactive-color="slategray"
                :active-value="1" :inactive-value="2">
              </el-switch>
            </template>
            <template v-else-if="index == 1">
              <el-input v-if="editing" size="small" :class="{'border-red':!scope.row.goodsNameCn}"
                :maxlength="item.max" v-model="scope.row.goodsNameCn"
                placeholder="必填" />
              <span v-else>{{scope.row.goodsNameCn}}</span>
            </template>
            <template v-else>
              <template v-if="editing">
                <InputNumber v-if="item.type === 'number'" v-model="scope.row[item.prop]"
                  :max="item.max" @change="onChangeTableData" :disabled="item.disabled"
                  :options="numberOpts" size="small" :min="item.min || 0"
                />
                <el-input v-else style="border-color:transparent" size="small"
                  :maxlength="item.max" v-model="scope.row[item.prop]"
                  placeholder="请输入" />
              </template>
              <span v-else>{{scope.row[item.prop]}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column width="80" class-name="header-center">
          <template slot="header" slot-scope="scope">
            <el-button v-if="editing" size="mini" type="success" @click="addRow(scope.$index, scope.row)">
              <span class="iconfont icontianjia"></span>
            </el-button>
            <span v-else></span>
          </template>
          <template scope="scope">
            <el-button v-if="editing" size="mini" type="danger" @click="deleteRow(scope.$index, scope.row)">
              <span class="iconfont iconshanchu"></span>
            </el-button>
            <span v-else></span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { commonApi, orderApi } from '@/service'
import { requiredBlur,requiredChange , max, numberDouble, numberInt, maxNum } from '@/utils/validate.js'
import { Message } from 'element-ui'
import InputNumber from '@/pages/components/input-number';
import LYForm from '@/pages/components/ly-form'
import { checkOpts } from '@/utils'

export default {
  name: 'OrderDetail',
  props: {
    editing: Boolean,
    orderData: Object,
    editDataCopy:Object,
  },
  components: { InputNumber, LYForm },
  data() {
    return {
      isCodeOption:[
        {
        value:true,
        label:'是'
        },
        {
        value:false,
        label:'否'
        }
      ],
      ifpickupOptions:[
        {
        value:true,
        label:'是'
        },
        {
        value:false,
        label:'否'
        }
      ],
      regionList:[],
      sender: [],
      receivers: [],
      formOpts: () => {
        return {
          defaultLabel: 130,
          defaultSpan:7 ,
          defaultOffset: 0,
          labelPosition: 'left'
        }
      },
      formConfig: () => [
        {
          type: 'card', class: 'order-detail_card', span: 24, children: [
            { label: '订单信息', type: 'div', class: 'order-detail_detail-title', span: 24, },
            { label: '数量(PCS):', type: 'number', prop: 'packageQuantity', disabled: !this.editing, span: 6 },
            { label: '总重量(kg):', type: 'number', prop: 'totalWeight', disabled: !this.editing, span: 6 },
            { label: '总体积(m³):', type: 'number', prop: 'totalVolume', disabled: !this.editing, span: 6 },
            { label: 'COD金额:', type: 'number', prop: 'codAmount', disabled: !this.editing, span: 6 },
            { label: '订单金额:', type: 'number', prop: 'orderAmount', disabled: !this.editing, span: 6 },
            { label: 'COD币种:', type: 'input', prop: 'currency', disabled: !this.editing, span: 6 },
            { label: '是否是Cod订单:', type: 'radio', prop: 'isCod',options:this.isCodeOption, disabled: !this.editing, span: 6 },
            { label: '是否自提:', type: 'radio', prop: 'ifpickup',options:this.ifpickupOptions, disabled: !this.editing, span: 6 },
          ]
        },
        {
          type: 'card', class: 'order-detail_card', span: 24, children: [
            { label: '发件人信息', type: 'div', class: 'order-detail_detail-title', span: 24, },
            { label: '发件方代码:', type: 'select', prop: 'sender', filterable:true, clearable:true, disabled: !this.editing, options: this.sender, onChange: this.onChangeSenders, placeholder: '请选择发件方代码',},
            { label: '发件人名称:', type: 'input', prop: 'name', disabled: !this.editing, placeholder: '请输入' },
            { label: '发件人电话:', type: 'input', prop: 'phone', disabled: !this.editing, placeholder: '请输入' },
            { label: '地区:', type: 'cascader', prop: 'region', options:this.regionList, disabled: !this.editing, placeholder: '请选择地区' },
            { label: '详细地址:', type: 'textArea', prop: 'address', disabled: !this.editing, rows: 1, span: 8, placeholder: '请输入详情地址' },
          ]
        },
        {
          type: 'card', class: 'order-detail_card', span: 24, children: [
            { label: '收件人信息', type: 'div', class: 'order-detail_detail-title', span: 24, },
            { label: '收件方代码:', type: 'select', prop: 'receiver', filterable:true, clearable:true, disabled: !this.editing, options: this.receivers, onChange: this.onChangeReceivers, placeholder: '请选择收件方代码',},
            { label: '收件人名称:', type: 'input', prop: 'receiver_name', disabled: !this.editing, placeholder: '请输入' },
            { label: '收件人电话:', type: 'input', prop: 'receiver_phone', disabled: !this.editing, placeholder: '请输入' },
            { label: '地区:', type: 'cascader', prop: 'receiver_region', options:this.regionList, disabled: !this.editing, placeholder: '请选择地区' },
            { label: '详细地址:', type: 'textArea', prop: 'receiver_address', disabled: !this.editing, rows: 1, span: 8, placeholder: '请输入详情地址' },
          ]
        },
      ],
      formRules: {
        packageQuantity: [requiredBlur,numberInt('数量(PCS)')],
        totalWeight: [requiredBlur,numberDouble('总重量')],
        totalVolume: [requiredBlur, numberDouble('总体积')],
        isCod: [requiredChange],
        codAmount: [requiredBlur],
        orderAmount: [requiredBlur],
        currency: [requiredBlur,max(32)],
        ifpickup: [requiredChange],
        sender: [requiredChange],
        name: [requiredBlur],
        phone: [requiredBlur],
        region: [requiredChange],
        address: [requiredBlur],
        receiver:[requiredChange],
        receiver_name: [requiredBlur],
        receiver_phone: [requiredBlur],
        receiver_region: [requiredChange],
        receiver_address: [requiredChange],
      },
      orderDetailRules: {},
      numberOpts: {
        symbol: '',
        format: '%v',
        thousand: ',',
        decimal: '.',
        precision: '0'
      },
      goodsColumns: [
        { label: '记录', prop: 'type', width: 50 },
        { label: '货物品名(中)', prop: 'goodsNameCn', type: 'textArea', width: 150 },
        { label: '货物品名(英)', prop: 'goodsNameEn', type: 'textArea', width: 150 },
        { label: '数量|QTY(pcs)', prop: 'quantity', width: 110, type: 'number',max: 10000,  class: 'pre-wrap' },
        { label: '商品单价', prop: 'unitPrice', width: 100, type: 'number', max: 10000, class: 'pre-wrap' },
        { label: '商品规格', prop: 'unit', width: 120, type: 'input', class: 'pre-wrap' },
        { label: '单价币种', prop: 'currency', width: 120, type: 'input',  class: 'pre-wrap' },
        { label: '海关编码|HS Code', prop: 'hsCode', width: 150, max: 32, hide: true, class: 'pre-wrap' },
      ],
      // sumRow: {
      //   no: '合计',
      //   kits: 0,
      //   weight: 0,
      //   number:0,
      //   length: 0,
      //   width:0,
      //   height:0,
      //   volume:0,
      //   declared_price:0,
      // },
      loading: false,
    };
  },
  // watch: {
  //   editing:{
  //     handler(newVal,oldVal){
  //       if(!newVal){
  //         this.orderData = JSON.parse(JSON.stringify(this.editDataCopy));
  //         this.calcTotal();
  //         this.showData();
  //       }else{
  //         if(!(this.orderData.goods[this.orderData.goods.length-1]).no){
  //           this.calcTotal();
  //           this.showData();
  //         }
  //       }
  //     }

  //   }
  // },
  computed: {},
  mounted() {
    this.getRegionList();
    // this.calcTotal();
    // this.showData();
    // this.getUserCodeList();
    this.fetchOptsDetail()
    this.onChangeSenders()
    setTimeout(() => {
      this.$refs.form.clearValidate()
    }, 0)
  },

  created() {
    this.fetchOptsDetail();
    // if(this.orderData.id){
    //   this.onChangeSenders();
    //   this.onChangeReceivers();
    // }
    console.log('hehe')
   },
  methods: {
    //获取地区下拉列表
    getRegionList(){
      commonApi.regionList()
      .then(res => {
        this.regionList = res.data;
      }).catch(error=>{

      })
    },
    // showData() {
    //   this.orderData.goods.push(this.sumRow)
    // },
    // calcTotal() {
    //   this.sumRow.kits = 0
    //   this.sumRow.weight = 0
    //   this.sumRow.number = 0
    //   this.sumRow.length = 0
    //   this.sumRow.width = 0
    //   this.sumRow.height = 0
    //   this.sumRow.volume = 0
    //   this.sumRow.declared_price = 0

    //   this.orderData.goods.forEach((item, index) => {
    //     if(this.editing){
    //       if(index < (this.orderData.goods.length-1)){
    //         this.sumRow.kits += parseInt(item.kits) || 0
    //         this.sumRow.weight +=  parseInt(item.weight) || 0
    //         this.sumRow.number +=  parseInt(item.number) || 0
    //         this.sumRow.length +=  parseInt(item.length) || 0
    //         this.sumRow.width +=  parseInt(item.width) || 0
    //         this.sumRow.height +=  parseInt(item.height) || 0
    //         this.sumRow.volume +=  parseInt(item.volume) || 0
    //         this.sumRow.declared_price += parseInt(item.declared_price) || 0
    //       }
    //     }else{
    //       if(index <= (this.orderData.goods.length-1)){
    //         this.sumRow.kits += parseInt(item.kits) || 0
    //         this.sumRow.weight +=  parseInt(item.weight) || 0
    //         this.sumRow.number +=  parseInt(item.number) || 0
    //         this.sumRow.length +=  parseInt(item.length) || 0
    //         this.sumRow.width +=  parseInt(item.width) || 0
    //         this.sumRow.height +=  parseInt(item.height) || 0
    //         this.sumRow.volume +=  parseInt(item.volume) || 0
    //         this.sumRow.declared_price += parseInt(item.declared_price) || 0
    //       }
    //     }

    //   })
    // },
    // getUserCodeList() {
    //   orderApi.userCodeList().then(res => {
    //     this.customerCodes = []
    //     this.customer_ids = []
    //     this.WarehousNumber = []
    //     res.data.customers.forEach(item=>{
    //       let obj_customer_code = {
    //         value: item.id,
    //         label: item.code
    //       }
    //       let obj_customer = {
    //         value: item.code,
    //       }
    //       this.customerCodes.push(obj_customer)
    //       this.customer_ids.push(obj_customer_code)
    //     })
    //     res.data.warehouses.forEach(item=>{
    //       let obj_warehouse_number = {
    //         value: item.warehouse
    //       }
    //       this.WarehousNumber.push(obj_warehouse_number)
    //     })
    //   }).catch(() => {

    //   })
    // },
    queryCustomerCodeSearch(queryString, cb) {
      var restaurants = this.customerCodes;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    queryWarehousNumberSearch(queryString, cb) {
      var restaurants = this.WarehousNumber;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    // handleSelectCreate(obj){
    //   for (let i = 0; i < this.customerCodes.length; i++){
    //     if (obj == this.customerCodes[i]){
    //       this.orderData.warehouse_number = this.WarehousNumber[i].value
    //       this.onChangeCustCode()
    //       return
    //     }
    //   }
    //   for (let i = 0; i < this.WarehousNumber.length; i++){
    //     if (obj == this.WarehousNumber[i]){
    //       this.orderData.customer_code = this.customerCodes[i].value
    //       this.onChangeCustCode()
    //       return
    //     }
    //   }
    // },

    //表头换行居中
   renderHeader(createElement, { column, _self }) {
      let label = column.label;
      let labelArr = label.split('/');
        return createElement(
          'div',
          {
          'class': 'header-center'
          },
          [
            createElement('div', {
                    attrs: { type: 'text' },
                }, [labelArr[0]]
                ),
                createElement('div', {
                    attrs: { type: 'text' },
                }, [labelArr[1] || '']
            )
          ]
      );
    },
    validate() {
      console.log(this.orderData.goods)
      let submitData = JSON.parse(JSON.stringify(this.orderData))
      // submitData.goods.splice(submitData.goods.length-1,1);
      if (submitData.goods.length > 0){
          let isSubmit = true;
          submitData.goods.some(item => {
            if (!item.goodsNameCn || !item.goodsNameEn || !item.unitPrice || !item.currency || !item.hsCode) {
              this.$msg({
                type: 'warning',
                message: '除‘货物品名(英)’和‘商品规格’外，其他字段为必填。'
              })
              isSubmit = false;
              return false
            }
          })
          if(isSubmit){
            return true
          }else{
            return false
          }
        }else{
          this.$msg({
            type: 'warning',
            message: '请填写货物详情'
          })
          return false
      }
      return this.$refs.form.validate()
    },
    initialGoodsData() {
      return {
        type: 1,
        goodsNameCn: '',
        goodsNameEn:'',
        quantity: 1,
        unitPrice:0,
        unit:'',
        currency:'SAR',
        hsCode: 'no data now',
      }
    },
    tableRowClassName({ row, rowIndex }) {
      return `type${row.type}`
    },
    addRow(index, row) {
      if (!this.editing) { return }
      // if(this.editing && this.orderData.goods[this.orderData.goods.length-1].no == '合计'){
      //   this.orderData.goods.splice(this.orderData.goods.length-1,1);
      // }
      this.orderData.goods.push(this.initialGoodsData())
      // this.showData()
      // this.calcTotal()
    },
    deleteRow(index, row) {
      if (!this.editing) { return }
      this.orderData.goods.splice(index, 1);
      this.onChangeTableData()
    },
    onChangeTableData() {
      this.orderData.packageQuantity = 0
      this.orderData.goods.forEach((item, index) => {
        this.orderData.packageQuantity += item.quantity
      })
      this.onChangeVWRate()
      // this.calcTotal()
    },
    onChangeVWRate() {
      if (!this.orderData.v_w_rate) {
        this.orderData.volume_w = 0;
        this.orderData.square_number = 0;
      } else {
        this.orderData.volume_w = (this.orderData.volume / this.orderData.v_w_rate).toFixed(2);
      }
      this.orderData.square_number = (this.orderData.volume_w / 167).toFixed(2)
      this.orderData.price_w = Math.max(this.orderData.volume_w, this.orderData.weight)

    },
    onChangeRowType(row) {
      row.kits = 1
      row.number = 1
      row.declared_price = 0
      row.sku_name = ''
      row.customs_code = ''
      this.onChangeTableData()
    },
    fetchOptsDetail() {
      orderApi.customerOpts().then(res => {
        this.sender = res.data;
      }).catch((err) => {
        console.log(err)
      })
    },
    onChangeSenders(){
      orderApi.customerDetail(this.orderData.sender).then(res => {
        this.$set(this.orderData, 'name', res.data.name)
        this.$set(this.orderData, 'phone', res.data.phone)
        this.$set(this.orderData, 'region', res.data.region)
        this.$set(this.orderData, 'address', res.data.address)
        this.receivers = res.data.receiver;
      }).catch(() => {
      })
    },
    onChangeReceivers() {
      orderApi.customerDetail(this.orderData.receiver).then(res => {
        this.$set(this.orderData, 'receiver_name', res.data.name)
        this.$set(this.orderData, 'receiver_phone', res.data.phone)
        this.$set(this.orderData, 'receiver_region', res.data.region)
        this.$set(this.orderData, 'receiver_address', res.data.address)
      }).catch(() => {
      })
    },
  },
};
</script>

<style lang="less" scoped>
#order-detail {
  min-height: 500px;
}
</style>
<style lang="less">
.tb-edit tr td {
  height: 48px;
  padding: 0;
  input {
    padding: 5px;
  }
  text-align: center;
  .pre-wrap .cell .header-center {
    white-space: pre-wrap!important;
  }
}
.tb-edit tr th .cell {
    padding: 0 5px!important;
}
.tb-edit .w70 .cell input{
  width: 70px!important;
}
.el-table .type2 {
  background: cornsilk;
}
.el-table .border-red {
  border: solid 1px orangered;
  border-radius: 4px;
}
.tb-edit .current-row.type2 {
  td {
    background: unset;
  }
}
.tb-edit tr:hover.type2 {
  background: cornsilk;
  td {
    background: unset;
  }
}
.order-detail-form .el-form-item__label {
  text-align: right;
}
.order-detail_card {
  margin-top: 10px;
}
.order-detail_detail-title {
  border-left: 8px solid #409eff;
  margin-bottom: 15px;
  font-size: 22px;
  font-weight: bold;
}
.header-center {
  text-align:center;
}
.header-center .cell{
  text-align:center;
}
.el-input__inner{
  height:35px;
  line-height:35px;
}
</style>

